import axios from 'axios';

export const moduleAccounts = {
	state() {
		return {
			accountList: [],
		};
	},
	mutations: {
		setAccountList(state, data) {
			state.accountList = data;
		},
	},
	getters: {
		getAccountList: (state) => state.accountList,
	},
	actions: {
		fetchAccountList({ commit, dispatch }) {
			commit('setAccountListLoader', true);
			/* eslint-disable */
			dispatch('newLogoutTime');
			return new Promise((resolve, reject) => {
				axios
					.get('Client/AccountSummaryList')
					.then((response) => {
						commit('setAccountList', response.data);
						commit('setAccountListLoader', false);
						resolve(true);
					})

					.catch((er) => {
						commit('setAccountListLoader', false);
					});
			});
		},
	},
};
